export default __webpack_public_path__ + "static/media/light.1b7855cb.svg";